import { ApolloError } from '@apollo/client';
import {
  ArticleTranslationVersionQuery,
  LanguageId,
  useArticleTranslationVersionQuery,
} from 'lib-knowledge-management-common/graphql';

export function useVersion({
  articleId,
  languageId,
  versionNumber,
}: {
  articleId: string;
  languageId: LanguageId;
  versionNumber: number | undefined;
}): {
  data: ArticleTranslationVersionQuery | undefined;
  loading: boolean;
  error?: ApolloError;
} {
  return useArticleTranslationVersionQuery({
    variables: {
      articleId,
      languageId,
      versionNumber: versionNumber!,
    },
    skip: !versionNumber,
    fetchPolicy: 'cache-and-network',
  });
}
